/**
 * THE PICTURES ITS OWN SITE CHOSE, on its page: the image a site marks for
 * when it is shared - usually the product's screenshot, the place's
 * storefront, or its logo. Read off pages the room already read
 * (`boardroom.images`), and only pages on its own site, so a review site's
 * picture never stands in for the thing reviewed.
 */
import { useState } from 'react';
import type { BoardroomSiteImage } from '../../../types';

export default function SiteImages({ images, name }: { images: BoardroomSiteImage[]; name: string }) {
  // A picture that will not load is left out rather than shown broken: the
  // address is the site's own and can go away at any time.
  const [broken, setBroken] = useState<Set<string>>(new Set());
  const shown = images.filter(i => !broken.has(i.url));
  if (!shown.length) return null;
  return (
    <section
      className="shrink-0 rounded-xl border border-gray-200 bg-white p-3 dark:border-gray-700 dark:bg-gray-800"
      data-testid="profile-images"
    >
      <h3 className="mb-2 text-[11px] uppercase tracking-wide text-gray-400">From {name}'s own site</h3>
      <div className="flex flex-wrap gap-3">
        {shown.map(img => (
          <a
            key={img.url}
            href={img.page ?? img.url}
            target="_blank"
            rel="noopener noreferrer"
            title={img.page ? `From ${img.page}` : img.url}
            className="block overflow-hidden rounded-lg border border-gray-100 bg-gray-50 dark:border-gray-700 dark:bg-gray-900"
          >
            <img
              src={img.url}
              alt={`${name}, as its site shows it`}
              loading="lazy"
              referrerPolicy="no-referrer"
              onError={() => setBroken(b => new Set(b).add(img.url))}
              className="h-32 max-w-[16rem] object-contain"
            />
          </a>
        ))}
      </div>
    </section>
  );
}
